import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

const BasicInfo = ({ asset, updateAssetField }) => {
  const [serialNumber, setSerialNumber] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subcategoryId, setSubcategoryId] = useState("");
  const [typeId, setTypeId] = useState("");

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [assetTypes, setAssetTypes] = useState([]);

  // -------------------------
  // LOAD DATA FROM ASSET
  // -------------------------
  useEffect(() => {
    if (asset) {
      setSerialNumber(asset.serial_number ?? "");
      setCategoryId(asset.assets_category_id ?? "");
      setSubcategoryId(asset.subcategory_id ?? "");
      setTypeId(asset.type_id ?? "");

      setCategories(asset.all_assets_categories || []);
      setSubcategories(asset.subcategory_list || []);
      setAssetTypes(asset.all_asset_type || []);
    }
  }, [asset]);

  // -------------------------
  // FETCH SUB-CATEGORY ON CATEGORY CHANGE
  // -------------------------
  const fetchSubcategories = async (catId) => {
    const res = await axios.get(`${API_BASE_URL}/asset/subcategories/${catId}`);
    setSubcategories(res.data);
  };

  const handleCategoryChange = (e) => {
    const newCat = e.target.value;
    setCategoryId(newCat);
    fetchSubcategories(newCat);
  };

  // -------------------------
  // SAVE FUNCTION
  // -------------------------
  const handleSave = (e) => {
    e.preventDefault();

    const payload = {
      assets_id: asset.assets_id,

      // New values
      serial_number: serialNumber,
      category_id: categoryId,
      subcategory_id: subcategoryId,
      type_id: typeId,

      // Old values
      old_serialNo: asset.serial_number,
      old_category: asset.category_name,
      old_subcategory: asset.subcategory_name,
      old_assetType: asset.type_name,

      // New text for logs
      new_category:
        categories.find(c => c.assets_category_id == categoryId)?.category_name || "",

      new_subcategory:
        subcategories.find(s => s.assets_subcategory_id == subcategoryId)?.category_name || "",

      new_assetType:
        assetTypes.find(t => t.type_id == typeId)?.type_name || "",
    };

    updateAssetField(payload);
  };

  return (
    <div className="card p-3">
      <h5 className="mb-3">Basic Information</h5>

      {/* ---------------------- FORM START ---------------------- */}
      <form onSubmit={handleSave}>
        <div className="row mb-3">

          {/* Company Asset Code */}
          <div className="col-md-4">
            <label>Company Asset Code</label>
            <input
              className="form-control"
              value={asset.company_asset_code}
              disabled
            />
          </div>

          {/* Serial Number */}
          <div className="col-md-4">
            <label>Serial Number</label>
            <input
              type="text"
              className="form-control"
              value={serialNumber}
              onChange={(e) => setSerialNumber(e.target.value)}
            />
          </div>

          {/* Category */}
          <div className="col-md-4">
            <label>Category</label>
            <select
              className="form-control"
              value={categoryId}
              onChange={handleCategoryChange}
            >
              <option value="">Select Category</option>
              {categories.map((c) => (
                <option key={c.assets_category_id} value={c.assets_category_id}>
                  {c.category_name}
                </option>
              ))}
            </select>
          </div>

        </div>

        <div className="row mb-3">

          {/* Sub-category */}
          <div className="col-md-4">
            <label>Sub Category</label>
            <select
              className="form-control"
              value={subcategoryId}
              onChange={(e) => setSubcategoryId(e.target.value)}
            >
              <option value="">Select Sub Category</option>
              {subcategories.map((sub) => (
                <option key={sub.assets_subcategory_id} value={sub.assets_subcategory_id}>
                  {sub.category_name}
                </option>
              ))}
            </select>
          </div>

          {/* Asset Type */}
          <div className="col-md-4">
            <label>Asset Type</label>
            <select
              className="form-control"
              value={typeId}
              onChange={(e) => setTypeId(e.target.value)}
            >
              <option value="">Select Type</option>
              {assetTypes.map((t) => (
                <option key={t.type_id} value={t.type_id}>
                  {t.type_name}
                </option>
              ))}
            </select>
          </div>

        </div>

        {/* SAVE BUTTON – clean and consistent */}
        <button className="btn btn-primary btn-sm mt-2" type="submit">
          Save
        </button>

      </form>
      {/* ---------------------- FORM END ---------------------- */}
    </div>
  );
};

export default BasicInfo;
